import styled from 'styled-components';
import { BREAKPOINT, PADDING } from '@latitude/core/utils/constants';
import { Link } from '@latitude/link';

export const StyledProofPointContainer = styled(Link)`
  display: flex;
  background-color: white;
  border-radius: 16px;
  border-bottom: none !important;
  text-shadow: none !important;
  padding: ${PADDING.P16} ${PADDING.P32};
  min-height: 80px;

  /* MOBILE — 1 per row */
  flex: 0 1 100%;
  max-width: 100%;

  /* TABLET — 2 per row */
  @media (min-width: ${BREAKPOINT.MD}) and (max-width: ${BREAKPOINT.LG}) {
    flex: 0 1 calc(50% - 24px);
  }

  /* DESKTOP — all items in one row */
  @media (min-width: ${BREAKPOINT.LG}) {
    
      flex: 1;
    
  }
`;

export const StyledProofPointContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  svg {
    width: 40px;
    height: 40px;
    flex-shrink: 0; /* prevents shrinking in flex */
  }
`;

export const StyledProofPointTextContainer = styled.div`
    width: stretch;
    a {
      border-bottom: none !important;
      text-decoration: none !important;
    }
`;

export const StyledProofPointIconContainer = styled.div`
     svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0; /* prevents shrinking in flex */
  }
`;
